import { ReactElement } from 'react';

import { FieldTypes, RenderingField, RenderingFieldGroup } from '@zinnia/form-engine-sdk';

import { ReactHtmlParser } from '@breathelife/ui-components';
import { isUnansweredField } from '../../Helpers';
import { BaseFieldProps } from '../FieldGenerator/FieldGenerator';
import { Field } from './Field';
import { Label, QuestionContainer } from './Styles';

export type PdfQuestionProps = BaseFieldProps & {
  avoidBreaks: boolean;
};

function isQuestionHidden(fieldGroup: RenderingFieldGroup): boolean {
  if (!fieldGroup.visible) {
    return true;
  }

  if (fieldGroup.showInPdfWithoutFields) {
    return false;
  }

  const fieldsDoNotExistOrAreAllUnanswered =
    !fieldGroup.fields.length ||
    fieldGroup.fields.every((field) => isUnansweredField(field) && field.type !== FieldTypes.information);
  if (fieldsDoNotExistOrAreAllUnanswered) {
    return true;
  }

  return false;
}

export function PdfQuestion(props: PdfQuestionProps): ReactElement | null {
  const { avoidBreaks, currency, locale, fieldGroup } = props;
  if (isQuestionHidden(fieldGroup)) return null;
  return (
    <QuestionContainer avoidBreakInside={avoidBreaks}>
      {fieldGroup.title && (
        <Label>
          <ReactHtmlParser html={fieldGroup.title} />
        </Label>
      )}
      {fieldGroup.text && (
        <Label data-testid={`question-text-${fieldGroup.id}`}>
          <ReactHtmlParser html={fieldGroup.text} />
        </Label>
      )}
      {fieldGroup.fields.map((field: RenderingField) => (
        <Field key={field.id} currency={currency} field={field} locale={locale} />
      ))}
    </QuestionContainer>
  );
}
